import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { Constants } from '../../../shared/models/common/constants';
import { LanguageService } from '../../../shared/services/language.service';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit, OnDestroy {

  lang$: Observable<any>;
  private error: any;
  private sub: any;
  constructor(private route: ActivatedRoute,
              private languageService: LanguageService) {}

  ngOnInit() {
    this.lang$ = this.languageService.languageType$;
    this.sub = this.route.params.subscribe(params => {
      this.error = params;
      console.log('this.error', this.error);
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  get constants() {
    return Constants;
  }

}
